import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ApiService from "../../../Service/ApiService";
import BookingItem from "../../booking_room/BookingItem";
import Header from "../../common/Header";

const EditBookingPage = () => {
  const navigate = useNavigate();
  const { bookingCode } = useParams();
  const [bookingDetails, setBookingDetails] = useState(null); // state variable for booking details
  const [error, setError] = useState(null); //track any error
  const [success, setSuccessMessage] = useState(null); // track any error

  useEffect(() => {
    const fetchBookingDetails = async () => {
      try {
        const response = await ApiService.getBookingByConfirmationCode(
          bookingCode
        );
        setBookingDetails(response);
      } catch (error) {
        setError(error?.message || "Failed to fetch booking details");
      }
    };

    fetchBookingDetails();
  }, [bookingCode]);

  return (
    <div className="find-booking-page">
      <Header title={"Manage Booking"} />
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}
      {bookingDetails && <BookingItem bookingDetails={bookingDetails} />}
    </div>
  );
};

export default EditBookingPage;
